import type { ReactNode } from "react";
import { DevErrorDisplay } from "../core/blocks/DevErrorDisplay";

type TableErrorWrapperProps = {
  children: ReactNode;
  error?: unknown;
  userMessage?: string;
};

export function TableErrorWrapper({ children, error, userMessage }: TableErrorWrapperProps) {
  if (error) {
    return <DevErrorDisplay error={error} userMessage={userMessage} />;
  }
  return <>{children}</>;
}
